import styled from "@emotion/styled";

const Value = styled.p`
  aspect-ratio: 1;
  background: var(--csa-green);
  border-radius: 0.25rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: normal;
  margin: 1rem 0 0;
  overflow: scroll;
  padding: 1.5rem 1rem;
`;

export default Value;
